import { render, staticRenderFns } from "./DataFilter.vue?vue&type=template&id=b346f850&scoped=true"
import script from "./DataFilter.vue?vue&type=script&lang=ts"
export * from "./DataFilter.vue?vue&type=script&lang=ts"
import style0 from "./DataFilter.vue?vue&type=style&index=0&id=b346f850&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b346f850",
  null
  
)

export default component.exports